<!--
 * @Author: Tang Hao
 * @Date: 2025-12-22 14:00:17
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-29 14:08:47
 * @Description:
-->
<template>
  <div>
    <div>
      1、设定的税率阶梯需满足连续性，即下一阶梯的区间最小值必须等于上一节点的区间最大值。<br />
      2、计算方式：单月单人的提现金额按阶梯分别计算需承担税金。红包提现产生的上浮服务费按打款时间时的提现情况进行计算。<br />
      3、至少需要设置一个税率阶梯，未设置税率阶梯的金额会打款失败。
    </div>
    <el-button type="primary" v-if="!disabled" @click="handleAdd" style="margin-bottom: 10px"
      >新增税率阶梯</el-button
    >
    <vxe-table ref="fineTable" :data="dataList">
      <vxe-column type="seq" title="序号" width="70"></vxe-column>

      <vxe-table-column min-width="100" field="minAmount" title="区间最小值（大于）">
        <template #default="{ row }">
          <el-input-number :disabled="disabled" v-model="row.minAmount" :min="0"></el-input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="maxAmount" title="区间最大值（小于等于）">
        <template #default="{ row, rowIndex }">
          <el-input-number :disabled="disabled" v-model="row.maxAmount" @change="handleMaxAmountChange(row, rowIndex)" :min="0"></el-input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="taxRate" title="税率（%）">
        <template #default="{ row }">
          <el-input-number :disabled="disabled" v-model="row.taxRate" :min="0"></el-input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="!disabled" width="70" field="createTime" title="操作">
        <template #default="{ row }">
          <el-button
            @click="handleDelete(row)"
            type="danger"
            icon="el-icon-delete"
            circle
          ></el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
export default {
  name: 'Payment',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataList: [],
    };
  },
  watch: {
    dataList: {
      handler(val) {
        this.handleChange(val);
      },
      deep: true,
    },
    value: {
      handler(val) {
        if (val && val.length > 0) {
          this.dataList = [...val];
        }
      },
      deep: true,
    },
  },
  methods: {
    handleAdd() {
      const before = this.dataList[this.dataList.length - 1];
      this.dataList.push({
        indexNum: this.dataList.length + 1,
        maxAmount: '',
        minAmount: before ? before.maxAmount : '',
        taxRate: '',
      });
    },
    handleDelete(row) {
      this.dataList = this.dataList.filter((item, index) => item.indexNum !== row.indexNum);
      this.dataList.forEach((item, index) => {
        item.indexNum = index + 1;
      });
    },
    handleChange(val) {
      this.$emit('input', val);
    },
    handleMaxAmountChange(row, rowIndex) {
      console.log('rowIndex', rowIndex);
      const next = this.dataList[rowIndex + 1];
      if (next) {
        next.minAmount = row.maxAmount;
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
